import { useState, useEffect } from 'react';
import { Paper, Typography, Button, Box, Link } from '@mui/material';

function PopupPrivacy() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Проверяем, давал ли пользователь согласие раньше
    const hasConsented = localStorage.getItem('cookieConsent');
    
    if (!hasConsented) {
      // Если не давал, показываем попап через 1 секунду (чтобы страница загрузилась)
      const timer = setTimeout(() => {
        setOpen(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Сохраняем согласие в localStorage
    localStorage.setItem('cookieConsent', 'true');
    setOpen(false);
    
    // Здесь можно добавить инициализацию Яндекс.Метрики
    // Например, динамически загрузить скрипт метрики
    console.log('Пользователь дал согласие на сбор статистики');
  };

  const handleDecline = () => {
    // Пользователь отказался
    localStorage.setItem('cookieConsent', 'false');
    setOpen(false);
    
    // Здесь можно отключить метрику или просто ничего не загружать
    console.log('Пользователь отказался от сбора статистики');
  };

  if (!open) return null;

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        maxWidth: 380,
        width: 'calc(100% - 40px)',
        p: 2.5,
        zIndex: 9999,
        backgroundColor: '#fff',
        borderRadius: 2,
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        animation: 'slideIn 0.3s ease-out',
        '@keyframes slideIn': {
          from: {
            transform: 'translateX(100%)',
            opacity: 0,
          },
          to: {
            transform: 'translateX(0)',
            opacity: 1,
          },
        },
      }}
    >
      <Typography variant="body2" gutterBottom sx={{ mb: 1.5 }}>
        Используется Яндекс.Метрика для сбора статистики. 
        Нажимая «Согласен», вы разрешаете обработку данных.
      </Typography>
      
      <Link 
        href="/privacy" 
        variant="body2"
        underline="hover"
        sx={{ 
          display: 'inline-block', 
          mb: 2,
          cursor: 'pointer',
          fontSize: '0.75rem'
        }}
      >
        Политика конфиденциальности
      </Link>
      
      <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'flex-end', mt: 1 }}>
        {/* <Button 
          variant="text" 
          size="small"
          onClick={handleDecline}
          sx={{ 
            color: '#666',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
          }}
        >
          Отказаться
        </Button> */}
        <Button 
          variant="contained" 
          size="small"
          onClick={handleAccept}
          sx={{ 
            backgroundColor: '#2196f3',
            textTransform: 'none',
            '&:hover': { backgroundColor: '#1976d2' }
          }}
        >
          СОГЛАСЕН
        </Button>
      </Box>
    </Paper>
  );
}

export default PopupPrivacy;